/**
 * Which URL a visualization should analyze for a clip scene.
 *
 * `mediaUrl` is what the scene *plays* — the source-resolution video for a
 * video asset. `audioUrl` is the audio-only rendition, present only when the
 * server confirmed it exists (`resolveTranscriptionAudio`), and it is the
 * cheaper thing to range-fetch and decode for an FFT: hundreds of kilobytes per
 * window instead of tens of megabytes.
 *
 * Deliberately not `getAssetUrls().audioUrl`, which names an `audio.m4a` for
 * every R2 video asset whether or not `copy-gcp` ever wrote one.
 */
export function sceneAudioSrc(clipScene: {
  mediaUrl: string
  audioUrl?: string | null | undefined
}): string {
  return clipScene.audioUrl ?? clipScene.mediaUrl
}
